"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var HeaderRow_1 = __importDefault(require("../HeaderRow"));
var headerRow = function (props) {
    return (react_1.default.createElement(HeaderRow_1.default, { title: props.text, level: props.level, badge: props.badge, badgeColor: props.badgeColor }, props.buttons && props.buttons()));
};
exports.default = headerRow;
//# sourceMappingURL=HeaderBar.js.map